import cn from "classnames";

import type { ArticleStyle } from "../../../types/content";
import type { Footer } from "../../../types/content/feedItem";
import type { BoxFooter } from "../../../types/content/boxFooter";

import styles from "./TeaserClusterFooter.module.scss";
import { Button } from "../../Button/Button";
import { getSlugFromTitle } from "../../../utils/getSlugFromTitle";

const getLink = ({ link }: BoxFooter) => {
  if (link.type === "story") {
    return link?.slug
      ? `/t/${link.slug}/${link.topic_id}`
      : `/t/${link.topic_id}`;
  } else if (link.type === "Category") {
    return `/${link.slug}`;
  }
};

function TeaserClusterFooter({
  items,
  style,
  hasBorder,
}: {
  items: Footer;
  style: ArticleStyle;
  hasBorder?: boolean;
}) {
  if (!items) {
    return null;
  }

  return (
    <div
      className={cn([
        styles.footerContainer,
        styles[style],
        !hasBorder && styles.noBorder,
      ])}
    >
      {items.content?.map((resource, index) => {
        if (resource.type === "ReadMoreButton") {
          const link = getLink(resource);

          return (
            <Button
              key={index}
              text={`${resource.value}`}
              size="small"
              variant="secondary"
              type="link"
              href={link}
              isPremium={style === "premium"}
            />
          );
        }
        if (
          resource.type === "FeedItemVignette" &&
          resource.link?.entityType === "topic"
        ) {
          const title = resource.primaryVignette;
          const id = resource.link?.entityId;

          const slug = getSlugFromTitle(title);

          return (
            <Button
              key={index}
              text={`Läs mer om ${title}`}
              variant="text"
              size="tiny"
              type="link"
              isPremium={style === "premium"}
              href={`/t/${slug}/${id}`}
            />
          );
        }
        return null;
      })}
    </div>
  );
}

export { TeaserClusterFooter };
